import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { FilterContainer } from '@/common/dashboard/FilterContainer';
import { Form } from '@/common/form/Form';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ContentBox } from '@/common/layout/MainBox';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { UsAmpChart } from './UsAmpChart';
import { UsAmpTableCard } from './UsAmpTableCard';

export const UsAmpDashboard = () => {
    
    const rsrc = useRsrc();

    const { navState } = useNavState();
    
    const [fieldDefs, setFieldDefs] = useState();
    const [formValues, setFormValues] = useNavStateSync('formValues');

    const [brandIdToBrandName, setBrandIdToBrandName] = useState();
    const [custIdToCustName, setCustIdToCustName] = useState();
    const [distChannelIdToDistChannel, setDistChannelIdToDistChannel] = useState();
    const [ctrtTypeIdToCtrtType, setCtrtTypeIdToCtrtType] = useState();

    useEffect(() => {
        rsrc.data('sc', 'US_AMP_DASHBOARD_FILTERS_DATA_PLUGIN', { }).then(res => {
            setFieldDefs([
                { field: 'subPeriodId', displayName: 'Submission Period', type: 'DROPDOWN', values: res.subPeriods },
                { field: 'invPeriodId', displayName: 'Invoice Period', type: 'DROPDOWN', values: res.invPeriods },
                { field: 'brandIds', displayName: 'Products', type: 'TREE', treeData: res.brandTreeData },
                { field: 'custIds', displayName: 'Customer', type: 'TREE', treeData: res.custTreeData },
                { field: 'distChannelIds', displayName: 'Distributor Channel', type: 'TREE', treeData: res.distChannelTreeData },
                { field: 'ctrtTypeIds', displayName: 'Contract Type', type: 'TREE', treeData: res.ctrtTypeTreeData }
            ]);

            if (!navState.formValues) {
                setFormValues({
                    subPeriodId: res.subPeriods[0].value,
                    invPeriodId: res.invPeriods[0].value,
                    brandIds: res.brandIds,
                    custIds: res.custIds,
                    distChannelIds: res.distChannelIds,
                    ctrtTypeIds: res.ctrtTypeIds
                });
            }
            setBrandIdToBrandName(res.brandIdToBrandName);
            setCustIdToCustName(res.custIdToCustName);
            setDistChannelIdToDistChannel(res.distChannelIdToDistChannel);
            setCtrtTypeIdToCtrtType(res.ctrtTypeIdToCtrtType);
        });
    }, []);

    if (!fieldDefs) {
        return;
    }

    return (
        <ContentBox>
            <Box sx={{
                mb: 1, display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start'
            }}>
                <Title icon={fas.faTasks} title="US AMP Dashboard" />
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} >
                </Box>
            </Box>

            {/* Filters */}
            <Form fieldDefs={fieldDefs} formValues={formValues} setFormValues={setFormValues} container={FilterContainer}/>

            <SpacerLayout>
                <Spacer vertical>
                    <Spacer weights={[1]}>
                        <DashboardCard title="Total Rebate Amount by Payment Dimension" sx={{ flex: 1 }} >
                            <UsAmpChart
                                formValues={formValues}
                                brandIdToBrandName={brandIdToBrandName}
                                custIdToCustName={custIdToCustName}
                                distChannelIdToDistChannel={distChannelIdToDistChannel}
                                ctrtTypeIdToCtrtType={ctrtTypeIdToCtrtType}
                            />
                        </DashboardCard>
                    </Spacer>
                    <Spacer weights={[1]}>
                        <UsAmpTableCard
                            formValues={formValues}
                            brandIdToBrandName={brandIdToBrandName}
                            custIdToCustName={custIdToCustName}
                            distChannelIdToDistChannel={distChannelIdToDistChannel}
                            ctrtTypeIdToCtrtType={ctrtTypeIdToCtrtType}
                        />
                    </Spacer>
                </Spacer>
            </SpacerLayout>
        </ContentBox>
    );
}